<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg6 offset-lg3 class="mt-5">
      <v-card>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">{{ $t('settings') }}</h3>
          <v-spacer></v-spacer>
          <v-btn flat large @click.prevent="logout">Ausloggen
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-tabs icons-and-text centered grow>
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab href="#tab-person">
            {{ $t('profile') }}
            <v-icon>person</v-icon>
          </v-tab>

          <v-tab href="#tab-password">
            {{ $t('password') }}
            <v-icon>lock</v-icon>
          </v-tab>

          <!--  <v-divider></v-divider> -->
          <v-tab-item value="tab-person">
            <profile-view v-on:busy="busy = $event"></profile-view>
          </v-tab-item>
          <v-tab-item value="tab-password">
            <password-view v-on:busy="busy = $event"></password-view>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Profile from '~/pages/settings/profile'
import Password from '~/pages/settings/password'
export default {
  name: 'settings-view',
  components: {
    'profile-view': Profile,
    'password-view': Password
  },
  data () {
    return {
      busy: false
    }
  },
  methods: {
    async logout () {
      this.busy = true

      // Log out the user.
      await this.$store.dispatch('logout')
      this.busy = false
      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>